import { render, staticRenderFns } from "./ClientInfo.vue?vue&type=template&id=5104648f&scoped=true"
import script from "./ClientInfo.vue?vue&type=script&lang=js"
export * from "./ClientInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5104648f",
  null
  
)

export default component.exports